export const CATEGORY_LIGHTBOX_OPENED = 'CATEGORY_LIGHTBOX_OPENED';
export const CATEGORY_VIEWED = 'CATEGORY_VIEWED';
